import { ImageLoaderProps } from 'next/image';
import * as qs from 'query-string';

/**
 * Функция для выгрузки оптимизированного изображения с кешированием через отдельный CDN домен.
 */
export default function cdnImageLoader({
    src,
    width,
    quality,
}: ImageLoaderProps): string {
    // SVG картинки не поддерживаются оптимизатором, поэтому их отдаем напрямую через CDN
    if (src.endsWith('.svg')) {
        if (src.startsWith('/')) {
            return `${process.env.NEXT_PUBLIC_CDN_DOMAIN}${src}`;
        }

        return src;
    }

    const publicCdnDomain = process.env.NEXT_PUBLIC_CDN_DOMAIN;

    // Если ссылка на изображение уже через CDN, то заменяем ее на прямую ссылку для предотвращения лишней рекурсии и оптимизации цепочки запросов
    if (src.startsWith(publicCdnDomain)) {
        src = src.replace(publicCdnDomain, process.env.NEXT_PUBLIC_JETLEND_MEDIA_ENDPOINT);
    }

    // Формируем ссылку на стандартный механизм оптимизации изображений внутри NextJS
    return `${publicCdnDomain}/_next/image/?${qs.stringify({
        url: src,
        w: width,
        q: quality ?? 80,
    })}`;
}